import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
import { useAppDispatch } from '../store';
import { clearError } from '../store/error/error.slice';

import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import { getFeatureFlagsThunk } from '../features/auth/api/featureFlagSlice';
import { SERVICE_TYPE_MOBILE } from '../config';
import useIsMobile from '../hooks/useIsMobile';
import { setMenuCollapsed } from '../features/account/api/accountSlice';
import { TAB_BREAKPOINT } from '../features/app/components/PageStepper';
import { verifyAllSessionCookies } from '../utils/sessionCookies';

export const AppRoutes = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticating, authStatus } = useAuth();
  const isMobile = useIsMobile(TAB_BREAKPOINT);
  const [routes, setRoutes] = useState(publicRoutes);

  useEffect(() => {
    if (isMobile) {
      dispatch(setMenuCollapsed(false));
    }
  }, [dispatch, isMobile]);

  useEffect(() => {
    dispatch(clearError());
    dispatch(getFeatureFlagsThunk(SERVICE_TYPE_MOBILE));
  }, [dispatch]);

  useEffect(() => {
    const updateRoutes = () => {
      if (verifyAllSessionCookies()) {
        setRoutes(protectedRoutes);
      } else {
        setRoutes(publicRoutes);
      }
    };
    updateRoutes();
    const handleCookieChange = () => {
      updateRoutes();
    };

    window.addEventListener('cookieChange', handleCookieChange);

    return () => {
      window.removeEventListener('cookieChange', handleCookieChange);
    };
  }, []);

  const commonRoutes: any = [];

  const router = createBrowserRouter([
    ...routes,
    ...commonRoutes,
    { path: '*', element: <Navigate to='/' replace /> },
  ]);

  if (isAuthenticating || authStatus === undefined) {
    return (
      <div className='d-flex flex-column min-vh-100 min-vw-100'>
        <div className='d-flex flex-grow-1 justify-content-center align-items-center'>
          <Spinner animation='border' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </Spinner>
        </div>
      </div>
    );
  }
  return <RouterProvider router={router} />;
};
